<app-navigation (menuButtonClick)="toggleSidenav()"></app-navigation>
<mat-sidenav-container>
    <mat-sidenav #sidenav class="w-100 p-4">
        <app-secondary-navigation (navItemClick)="toggleSidenav()"></app-secondary-navigation>
    </mat-sidenav>
    <mat-sidenav-content>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
<app-footer></app-footer>
